import type { FaireProductEntity } from "../../entity_types/product";

export const driftless_studios_3: FaireProductEntity = {
  token: "driftless-studios-3",
  type: "product",
  name: "Best Mom Ever! - Mothers Day Candle - Soy Wax Candles",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/adc72f57bbf771af93869cce20403aefa3101dc2140f4302efb35270fceac0f6.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 14.5,
  msrpDollars: 26,
  freeShipping: true,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
